import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchMealRestrictionsApi = async () => {
  const response = await axiosInstance.get(Endpoints.GET_MEAL_RESTRICTIONS);
  return response.data;
};

export const fetchRecipesFilterApi = async ({ requestPayload, mealTime }) => {
  try {
    const toPascalCase = (str) => {
      const lower = str.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    };

    let normalizedMealTime;

    switch (mealTime) {
      case "SNACK1":
        normalizedMealTime = "Snack";
        break;
      case "LUNCH1":
        normalizedMealTime = "Lunch";
        break;
      default:
        normalizedMealTime = toPascalCase(mealTime);
        break;
    }
    const response = await axiosInstance.post(
      `${Endpoints.GET_CUSTOMIZED_RECIPES}?mealType=${normalizedMealTime}`,
      {
        ...requestPayload,
      }
    );

    const rawRecipes = response?.data || [];

    const recipes = rawRecipes.map((recipe) => {
      return {
        ...recipe,
        // Ensure ingredients is an array (sometimes it's a single comma-separated string)
        ingredients: Array.isArray(recipe.ingredients)
          ? recipe.ingredients.flatMap((ing) =>
              typeof ing === "string"
                ? ing.split(";").map((s) => s.trim())
                : ing
            )
          : [],
        // Ensure instructions is an array of steps (split if provided as one string with commas)
        instructions: Array.isArray(recipe.instructions)
          ? recipe.instructions.flatMap((step) =>
              typeof step === "string"
                ? step.split(";").map((s) => s.trim())
                : step
            )
          : [],
      };
    });
    // console.log("test_mealTime", recipes);
    return { [mealTime]: recipes };
  } catch (error) {
    throw new Error(error.response?.data || "Failed to fetch recipes");
  }
};

export const fetchRecipesBasedMealTypeReplaceRecipeModalApi = async ({
  requestPayload,
  mealTime,
}) => {
  try {
    const toPascalCase = (str) => {
      const lower = str.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    };

    let normalizedMealTime;

    switch (mealTime) {
      case "SNACK1":
        normalizedMealTime = "Snack";
        break;
      case "LUNCH1":
        normalizedMealTime = "Lunch";
        break;
      default:
        normalizedMealTime = toPascalCase(mealTime);
        break;
    }

    const response = await axiosInstance.post(
      `${Endpoints.GET_STANDARD_RECIPES}?mealType=${normalizedMealTime}`,
      {
        ...requestPayload,
      }
    );
    const rawRecipes = response?.data || [];

    const recipes = rawRecipes.map((recipe) => {
      return {
        ...recipe,
        // Ensure ingredients is an array (sometimes it's a single comma-separated string)
        ingredients: Array.isArray(recipe.ingredients)
          ? recipe.ingredients.flatMap((ing) =>
              typeof ing === "string"
                ? ing.split(",").map((s) => s.trim())
                : ing
            )
          : [],
        // Ensure instructions is an array of steps (split if provided as one string with commas)
        instructions: Array.isArray(recipe.instructions)
          ? recipe.instructions.flatMap((step) =>
              typeof step === "string"
                ? step.split(",").map((s) => s.trim())
                : step
            )
          : [],
      };
    });
    // console.log("test_mealTime", recipes);
    return { [mealTime]: recipes };
  } catch (error) {
    throw new Error(error.response?.data || "Failed to fetch recipes");
  }
};

export const fetchMealTagsApi = async ({ mealTime }) => {
  try {
    const response = await axiosInstance.get(
      Endpoints.GET_FILTERED_RECIPE_WITH_MEAL_TIME,
      {
        params: { mealTime },
      }
    );

    return (
      response.data?.data?.recipeSearch?.edges?.map((edge) => edge.node) || []
    );
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch meals.";
  }
};

export const fetchMealMealPlanDetailsApi = async ({ clientId }) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_MEAL_PLAN_DETAILS}/client/${clientId}`
    );

    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch meals plan details."
    );
  }
};

//fetch coach profile
export const createMealPlanApi = async (requestPayload) => {
  const response = await axiosInstance.post(
    Endpoints.UPSERT_MEAL_PLAN,
    requestPayload
  );
  return response?.data;
};

export const fetchMacroSplitTemplatesApi = async () => {
  const response = await axiosInstance.get(Endpoints.GET_MACRO_SPLIT_TEMPLATES);
  return response.data;
};
